import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "styles/component.css";

const FloatingApplyButton = ({ onOpen }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = (e) => {
    e.stopPropagation();
    setIsVisible(false);

    // 5 daqiqadan keyin qayta ko'rsatish
    setTimeout(() => {
      setIsVisible(true);
    }, 5 * 60 * 1000);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fab-wrapper"
          initial={{ opacity: 0, scale: 0.7, y: 50 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.7, y: 50 }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 25,
            duration: 0.6,
          }}
        >
          <motion.div
            className="fab-tooltip"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 15 }}
            transition={{ delay: 0.2, duration: 0.4 }}
          >
            <span className="tooltip-text">Ariza topshirish</span>

            <button
              onClick={handleClose}
              className="tooltip-close"
              aria-label="Yopish"
            >
              ×
            </button>
          </motion.div>

          <motion.button
            onClick={onOpen}
            className="fab-button"
            whileHover={{ scale: 1.12, rotate: 5 }}
            whileTap={{ scale: 0.95 }}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.3, type: "spring", stiffness: 300 }}
          >
            <span className="pulse pulse-1"></span>
            <span className="pulse pulse-2"></span>
            <span className="pulse pulse-3"></span>

            <svg
              className="fab-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingApplyButton;
